/* eslint-disable no-console */
import { useState } from 'react';
import { Banner, BannerItem, Button } from '@athena/forge';
import { getLocalizedString } from '../../utils/i18n-utils';
import withEventHelper from '../common/EventHelper';
import { useEventBus } from '../../hooks/useEventBus';
import { navigateToTerminalViewWithError, showWidgetForm, startSpinner } from '../../utils/widget-facade';
import { resetUserAccount } from '../../utils/iam-core-client';
import { launchLwa } from '../../utils/lwa-utils';
import AmplitudeUtils from '../../utils/amplitude-utils';

function ResetAccountSection() {
  const [ loading, setLoading ] = useState(false);
  const [ display, setDisplay ] = useState(false);
  useEventBus({ eventName: 'render-reset-account-screen', onEvent: () => {
    setDisplay(true);
    AmplitudeUtils.logCustomEvent('AccountReset::Landing', {});
  } });

  const onResetAccount = async () => {
    setLoading(true);
    try {
      const response = await resetUserAccount();
      const emailToken = response.emailToken.token;
      await AmplitudeUtils.logCustomEvent('AccountReset::Success', {});
      await launchLwa({ emailToken });
    }
    catch (error) {
      await AmplitudeUtils.logCustomEvent('AccountReset::Error', { error });
      navigateToTerminalViewWithError('accountreset.error');
    }
  };
  const onCancel = () => {
    setDisplay(false);
    showWidgetForm();
  };
  if (display) {
    loading && startSpinner();
    return (
      <>
        <Banner alertType={loading ? 'info' : 'attention'}>
          <BannerItem
            headerText={
              loading
                ? getLocalizedString('accountreset.loading.title')
                : getLocalizedString('accountreset.warning.title')
            }
          >
            {loading ? getLocalizedString('accountreset.loading') : getLocalizedString('accountreset.warning')}
          </BannerItem>
        </Banner>
        {!loading && (
          <>
            <Button
              text={getLocalizedString('accountreset.button')}
              variant="primary"
              size="large"
              fullWidth={true}
              onClick={onResetAccount}
              className="fe_u_margin--top-medium"
            />
            <Button
              text={getLocalizedString('cancel')}
              variant="secondary"
              size="large"
              fullWidth={true}
              onClick={onCancel}
              className="fe_u_margin--top-small reset-account-cancel-button"
            />
          </>
        )}
      </>
    );
  }
  return <></>;
}

ResetAccountSection.displayName = 'ResetAccountSection';
export default withEventHelper(ResetAccountSection);
